import { defineMessages } from '@cookbook/solid-intl'

// Split out of `newsroom-page.messages.en.js` so the router's document-title/meta-
// description wiring doesn't have to eagerly pull that entire page's messages file
// into the boot-critical chunk just for these strings. Same pattern/rationale as
// `tos-page-routing.messages.en.js` / `privacy-page-routing.messages.en.js`
// (TENANT-5036 bundle audit).
export const messages = {
    descriptionMessage: defineMessages({
        defaultMessage: 'Hosting advice and news from Lodgr. Practical insights to help you get more from short-term rentals.',
        id: 'NewsroomPage.descriptionMessage',
    }),
    titleMessage: defineMessages({
        defaultMessage: 'Newsroom - Short-Term Rental Tips & News | Lodgr',
        id: 'NewsroomPage.titleMessage',
    }),
}
